<template>
  <div class="mb-2">
    <v-text-field
        outlined
        hide-details="auto"
        class="mb-3"
        :rules="[
                  (v) => (v===null || v==='') || (v && String(v).replace(/,/g, '.')==parseFloat(String(v).replace(/,/g, '.'))) || $t('form.validationErrors.must_be_float'),
                ]"
        v-model="tempParams.vat"
        :label="$t('goods.vat')"
    ></v-text-field>
    <h4>{{ $t("viewSettings.goods_export.category") }}: {{ (activeCategoryTitle !== null && !hasActiveCategoryChildren) ? `[${activeCategoryTitle}]` : '-'  }}</h4>
    <div style="max-height: 200px; overflow-y: auto">
      <v-treeview
        v-if="paramsValues"
        activatable
        :active.sync="activeCategoryId"
        :items="paramsValues.result"
        @update:active="getActiveCategoryValue"
        item-text="title"
        item-key="category_id"

      >
      </v-treeview>
    </div>
    <v-progress-circular
      v-if="!isFetchedCategoryAttributes"
      size="32"
      indeterminate
      color="primary"
    ></v-progress-circular>
    <template v-if="categoryAttributeWithValues">
      <template
        v-for="attribute in categoryAttributeWithValues.filter(
          (item) => item.values && item.values.length
        )"
      >
        <v-autocomplete
            class="mt-5"
            @change="setAttribute($event, attribute)"
            v-model="activeAttributes[attribute.name]"
            hide-details
            :items="attribute.values"
            item-text="value"
            return-object
            outlined

            small-chips
            :label="attribute.name"
            multiple
        ></v-autocomplete>
      </template>
    </template>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  name: "GoodsExportFormOzon",
  props: ["params", "params-values", "storage"],
  data: () => ({
    tempParams: {
      category_id: null,
      attributes:[],
      vat: null
    },
    activeCategoryId: [],
    activeAttributes:{}
  }),
  beforeMount() {
    if(this.params.data && this.params.data.category_id){
      this.tempParams.vat = this.params.data.vat
      this.tempParams.attributes = this.params.data.attributes
      this.tempParams.category_id = this.params.data.category_id;
      this.activeCategoryId.push(this.tempParams.category_id);
    } else {
      this.categoryAttributeWithValues = null;
      this.activeAttributes = {}
    }

  },
  watch: {
    tempParams(params){
      params.storage_id = this.storage.id;
      this.$emit("update:params", params);
    },
    activeCategoryId(id) {
      if (id && id[0] && !this.hasActiveCategoryChildren) {
        this.tempParams.category_id = id[0];
        this.$store.dispatch("ozon_seller_api/getCategoryAttributes", {
          category_id: id[0],
        }).then(()=>{
          this.activeAttributes = {}
          if(this.tempParams && this.tempParams.attributes){
            this.categoryAttributeWithValues.forEach((attribute)=>{
              this.tempParams.attributes.forEach((savedAttribute)=>{
                if(attribute.id === savedAttribute.id){
                  this.activeAttributes[attribute['name']]=[];
                  attribute.values.forEach(value=>{
                    savedAttribute.values.forEach(savedValue=>{
                      if(value.value === savedValue.value){
                        this.activeAttributes[attribute['name']].push(value)
                      }
                    })
                  })
                }
              })
            })
            this.activeAttributes = {...this.activeAttributes}
          }
        })
        this.activeAttributes = {}
      } else {
        this.tempParams.category_id = null;
        this.tempParams.attributes = [];
        this.categoryAttributeWithValues = null;
        this.activeAttributes = {}
      }
    },
  },
  computed: {
    activeCategoryTitle(){
      let categoryId = null;
      if(this.activeCategoryId && this.activeCategoryId[0]){
        categoryId = this.activeCategoryId[0];
      }
      let title = null;
      if(this.paramsValues && this.paramsValues.result && this.activeCategoryId[0]){
        this.paramsValues.result.forEach((item)=>{
          let  temp =  this.findFieldById(item, categoryId, 'title');
          title = temp ? temp : title;
        })
      }
      return title;
    },
    hasActiveCategoryChildren(){
      let categoryId = null;
      if(this.activeCategoryId && this.activeCategoryId[0]){
        categoryId = this.activeCategoryId[0];
      }
      let has = false;
      if(this.paramsValues && this.paramsValues.result && this.activeCategoryId[0]){
        this.paramsValues.result.forEach((item)=>{
          let  temp =  this.findFieldById(item, categoryId, 'children');
          has = !temp.length;
        })
      }
      return !has;
    },
    ...mapFields("storages", [
      "storageExportParams",
      "nowUpdatingExportForStorageWithId",
      "storageExportParamsValues",
    ]),
    ...mapFields("ozon_seller_api", [
      "categoryAttributeWithValues",
      "isFetchedCategoryAttributes",
    ]),
  },
  methods: {
    hasChildren(){
      let categoryId = null;
      if(this.activeCategoryId && this.activeCategoryId[0]){
        categoryId = this.activeCategoryId[0];
      }
      let title = null;
      if(this.paramsValues && this.paramsValues.result && this.activeCategoryId[0]){
        this.paramsValues.result.forEach((item)=>{
          let  temp =  this.findFieldById(item, categoryId, 'title');
          title = temp ? temp : title;
        })
      }
      return title;
    },
    findFieldById(item, categoryId, fieldName){
      let value = null;
      if(parseInt(item.category_id)===parseInt(categoryId)){
        return item[fieldName];
      } else {
        if(item.children){
          item.children.forEach((item)=>{
            let temp = this.findFieldById(item, categoryId, fieldName)
            value = temp ? temp : value;
          })
        }
      }
      return value;
    },
    setAttribute(values, selectedAttribute) {
      let isNewAttribute = true;
      if(this.tempParams.attributes.length > 0){
        this.tempParams.attributes.forEach((attribute)=>{
          if(attribute.id === selectedAttribute.id){
            isNewAttribute = false;
            attribute.values = [];
            values.forEach((value)=>{
              attribute.values.push({
                "value": value.value,
                "dictionary_value_id":value.id
              })
            })

          }
        })
      }
      if(isNewAttribute){
        let newValues = []
        values.forEach((value)=>{
          newValues.push({
            "value": value.value,
            "dictionary_value_id":value.id
          })
        })
        let attribute = {
          "complex_id": 0,
          "id": selectedAttribute.id,
          "values": newValues
        }
        this.tempParams.attributes.push(attribute)
      }
      this.tempParams = {...this.tempParams}
    },
    getActiveCategoryValue(value) {
      this.tempParams.category_id = value.length ? value[0] : null;
      this.tempParams.attributes=[];
      this.activeAttributes = {}
      this.activeAttributes = {...this.activeAttributes}
    }
  },
};
</script>

<style scoped></style>
